import { jsx as _jsx } from "react/jsx-runtime";
import { hydrateComponentByClassWithData } from '../../common/mount-helpers';
import { HomePage } from './homepage';
window.addEventListener('load', () => {
    hydrateComponentByClassWithData('home-page-wrappper', (props) => _jsx(HomePage, { ...props }));
});
